<template>
    <svg :viewBox="`0 0 ${width} ${height}`" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">
        <rect :width="width" :height="height" fill="#0f172a" />

        <!-- TV body -->
        <rect x="14%" y="12%" width="72%" height="52%" rx="6" ry="6" fill="#1e293b" stroke="#334155" stroke-width="2" />
        <!-- TV screen -->
        <rect x="18%" y="16%" width="64%" height="44%" rx="3" ry="3" fill="#0f172a" />
        <!-- TV stand neck -->
        <rect x="46%" y="64%" width="8%" height="10%" fill="#1e293b" />
        <!-- TV stand base -->
        <rect x="32%" y="74%" width="36%" height="5%" rx="3" ry="3" fill="#1e293b" stroke="#334155" stroke-width="1.5" />

        <!-- Antenna left -->
        <line x1="38%" y1="12%" x2="28%" y2="3%" stroke="#475569" stroke-width="2" stroke-linecap="round" />
        <!-- Antenna right -->
        <line x1="62%" y1="12%" x2="72%" y2="3%" stroke="#475569" stroke-width="2" stroke-linecap="round" />

        <!-- Screen static lines -->
        <line x1="18%" y1="30%" x2="82%" y2="30%" stroke="#1e3a5f" stroke-width="1" opacity="0.4" />
        <line x1="18%" y1="40%" x2="82%" y2="40%" stroke="#1e3a5f" stroke-width="1" opacity="0.4" />
        <line x1="18%" y1="50%" x2="82%" y2="50%" stroke="#1e3a5f" stroke-width="1" opacity="0.4" />

        <!-- Title text -->
        <text
            x="50%"
            y="91%"
            fill="#64748b"
            font-family="sans-serif"
            font-size="11"
            text-anchor="middle"
            dominant-baseline="middle"
        >{{ title }}</text>
    </svg>
</template>

<script>
export default {
    name: 'TvPlaceholder',
    props: {
        title: {
            type: String,
            default: ''
        },
        width: {
            type: Number,
            default: 320
        },
        height: {
            type: Number,
            default: 80
        }
    }
}
</script>
